import Vue from 'vue'
import Vuex from 'vuex'
import { getAPI } from './axios-api'
import jwt_decode from "jwt-decode"
import createPersistedState from "vuex-persistedstate";
import router from './router';

Vue.use(Vuex)
export default new Vuex.Store({

    plugins: [createPersistedState()],
    state: {
        accessToken: null,
        refreshToken: null,
        isLoggedIn: false,
        APIData: '',
        DeviceSelected : '',
        usableData: '',
        userName: localStorage.getItem('user_name') || 'Agent',
        userEmail: localStorage.getItem('user_email') || '',
        hasPunchedIn: localStorage.getItem('hasPunchedIn') || false,
        punchTime: localStorage.getItem('punchTime') || false,
    },
    getters : {
        Dev : state => {
            return state.DeviceSelected
        }
    },
    mutations: {
        updateStorage(state) {
            state.accessToken = localStorage.getItem('access_token')
            state.refreshToken = localStorage.getItem('refresh_token')

        },
        refreshStorage(state){
            state.accessToken = localStorage.getItem('access_token')
        },
        refreshTask(state,refreshTask) {
            state.refreshTimer = refreshTask  
        },
        cancelRefreshing(state) {
            clearTimeout(state.refreshTimer)
        },
        unsetUserData: (state) => {
            
            state.isLoggedIn = false
            state.accessToken = null
            state.refreshToken = null
            state.userName = 'Agent'
            state.email = ''
            
        },
        setUserInfo(state, userData) {
            state.userName = userData.full_name || 'Agent'
            state.userEmail = userData.email || ''
        },
        setAttendanceData(state, payload) {
            state.hasPunchedIn = payload.status;
            state.punchTime = payload.time;
            
            // Redundant if using persistedstate plugin, but safe to keep
            localStorage.setItem('hasPunchedIn', payload.status);
            if(payload.time) localStorage.setItem('punchTime', payload.time);
        },
        
    },
    actions: {
        fetchAttendanceStatus(context) {
            return new Promise((resolve, reject) => {
                const accessToken = localStorage.getItem('access_token')
                
                getAPI.get('/attendance/status/', {
                    headers: { Authorization: `Bearer ${accessToken}` }
                })
                .then(response => {
                    const hasPunchedIn = response.data.has_punched_in;
                    const punchTime = response.data.punch_in_time;

                    // USE MUTATION
                    context.commit('setAttendanceData', {
                        status: hasPunchedIn,
                        time: punchTime
                    });
                    resolve(response.data); 
                })
                .catch(err => {
                    reject(err);
                });
            });
        },
        userLogin(context, userCredentials) {
            return new Promise((resolve, reject) => {
                // Step 1: Get the Auth Token
                getAPI.post('/api-token/', {
                    email: userCredentials.email,
                    password: userCredentials.password,
                })
                .then(response => {
                    const accessToken = response.data.access
                    
                    // Save Tokens
                    localStorage.setItem('access_token', accessToken)
                    localStorage.setItem('refresh_token', response.data.refresh)
                    context.commit('updateStorage')
                    context.commit('isLoggedIn', true)
                    context.dispatch('autoRefresh')
    
                    // Step 2: Fetch Profile AND Attendance in PARALLEL
                    // We use Promise.all to fire both requests at once to save time
                    const headers = { Authorization: `Bearer ${accessToken}` }
                    
                    const requestProfile = getAPI.get('/agent-personal-info/', { headers })
                    const requestAttendance = getAPI.get('/attendance/status/', { headers })
    
                    return Promise.all([requestProfile, requestAttendance])
                })
                .then(([profileRes, attendanceRes]) => {
                    // This block runs only when BOTH requests finish successfully
                    
                    // A. Handle Profile Data
                    const fullName = `${profileRes.data.first_name} ${profileRes.data.last_name}`
                    localStorage.setItem('user_name', fullName)
                    localStorage.setItem('user_email', userCredentials.email)
                    
                    context.commit('setUserInfo', { 
                        full_name: fullName, 
                        email: userCredentials.email 
                    })
    
                    // B. Handle Attendance Data
                    const hasPunchedIn = attendanceRes.data.has_punched_in
                    const punchTime = attendanceRes.data.punch_in_time // "14:30:00" or null
                    
                    context.commit('setAttendanceData', {
                        status: hasPunchedIn,
                        time: punchTime
                    });
    
                    console.log("Login Complete. User:", fullName, "Status:", hasPunchedIn, "Entry Time:", punchTime);
    
                    // Resolve with the data needed for redirection
                    resolve({ hasPunchedIn, punchTime })
                })
                .catch(err => {
                    console.error("Login failed or Data fetch failed:", err)
                    reject(err)
                })
            })
        },
        refreshTokens (context) {
            return new Promise((resolve, reject) => {
            // Do whatever you need to do to exchange refresh token for access token
                getAPI.post('/api-token/refresh/', {
                    refresh: localStorage.getItem('refresh_token')
    
                })
                .then(response => {
                    localStorage.setItem('access_token', response.data.access)
                    context.commit('refreshStorage')
                    context.dispatch('autoRefresh')
                    console.log("Token Refreshed")
                    context.commit('isLoggedIn', true)
                    resolve()
                })
                .catch(err => {
                    reject(err)
                })
            // Finally, call autoRefresh to set up the new timeout
            
          })
        },
        autoRefresh (context) {
            
            const { state, commit, dispatch } = context
            
            const accessToken_  = state.accessToken
            
            const { exp } = jwt_decode(accessToken_)
            
            const now = Date.now() / 1000 // exp is represented in seconds since epoch
            let timeUntilRefresh = exp - now
            timeUntilRefresh -= (2 * 60) // Refresh 2 minutes before it expires
            const refreshTask = setTimeout(() => dispatch('refreshTokens'), timeUntilRefresh * 1000)
            commit('refreshTask', refreshTask) // In case you want to cancel this task on logout
        },
        logoutUser(context) {
            return new Promise((resolve, reject) => {
                try{
                    context.commit('unsetUserData')
                    context.commit('cancelRefreshing')
                    localStorage.removeItem('access_token')
                    localStorage.removeItem('refresh_token')
                    localStorage.removeItem('user_name')
                    localStorage.removeItem('user_email')
                    localStorage.clear()

                    router.push({ name: 'Login' }).catch(err => {console.log(err)})
                    resolve()
                }
                catch(err){
                    reject(err)
                }
               

            })
            
            
        },
        DeviceInfo(context, Info){
            this.state.DeviceSelected = Info
            localStorage.setItem('DeviceSelected',Info.name)
        }
    }
})

// Enable Vuex hot module replacement in development
if (module.hot) {
    module.hot.accept([], () => {
        // Vuex store hot reload is handled by Vue's module system
        // This ensures state persists across store updates in dev mode
    })
}
